import * as _ from 'lodash-es';
import { RuoliUtente } from '@hm_app/@core/models/utente';

export function firstRole(roles: string | string[]): RuoliUtente {
    if (!roles) {
        return null;
    }

    if (_.isArray(roles)) {
        return roles.length > 0 ? roles.length[0] : null;
    }
    return roles as RuoliUtente;
}

export function monitorRole(roles: string | string[]): boolean {
    return monitorRoles(roles).length > 0;
}

export function adminOrOperatorRole(roles: string | string[]): boolean {
    return adminOrSuperAdminRole(roles) || operatorRole(roles);
}

export function operatorRole(roles: string | string[]): boolean {
  return operatorRoles(roles).length > 0;
}

export function adminOrSuperAdminRole(roles: string | string[]): boolean {
    return adminRoles(roles).length > 0;
}

export function superAdminRole(roles: string | string[]): boolean {
    // caso semplice, subito ok
    if (roles == RuoliUtente.superadmin) {
        return true;
    }

    if (!roles) {
        return false;
    }

    if (!_.isArray(roles)) {
        roles = [roles as string];
    }

    return _.find(roles, RuoliUtente.superadmin) > -1;
}

export function adminRoles(roles: string | string[]): string[] {
    if (!roles) {
        return [];
    }

    if (!_.isArray(roles)) {
        roles = [roles as string];
    }

    return _.intersection([
        RuoliUtente.superadmin,
        RuoliUtente.admin,
    ], roles);
}


export function operatorRoles(roles: string | string[]): string[] {
  if (!roles) {
      return [];
  }

  if (!_.isArray(roles)) {
      roles = [roles as string];
  }

  return _.intersection([
      RuoliUtente.ostetrica,
      RuoliUtente.medico_generico,
      RuoliUtente.medico_ginecologo,
      RuoliUtente.operatore,
  ], roles);
}

export function monitorRoles(roles: string | string[]): string[] {
    if (!roles) {
        return [];
    }

    if (!_.isArray(roles)) {
        roles = [roles as string];
    }

    return _.intersection([
        RuoliUtente.monitor,
    ], roles);
}
